module.exports = __webpack_public_path__ + "img/phone-icon-white.b340dffc.svg";